// Apply only fields confirmed by the existing POST contract; keep pagination intact.
export function applyManualReconciliation(rows, result) {
  return rows.map(receipt => receipt.id !== result.receipt_id ? receipt : {
    ...receipt,
    reconciliation_status: result.new_status,
    reconciliation_details: {
      manual_override: true,
      verified_by: result.verified_by,
      comment: result.comment || 'Verificación manual',
      receipt_amount: receipt.amount,
      bank_amount: receipt.amount,
      bank_date: receipt.date,
      ...(receipt.reconciliation_details
        ? { automatic_details: receipt.reconciliation_details } : {}),
    },
  });
}
